// extracted by mini-css-extract-plugin
export default {"LinkEditor-link":"LinkEditor-link1KRjLF0oG7-k","LinkEditor-URL":"LinkEditor-URL1ogzhmmV_RKg","LinkEditor":"LinkEditor3EQCEXu0YdtH"};